
import { Injectable } from '@angular/core';
import { BooleanLiteral } from 'typescript/lib/tsserverlibrary';
import { Parent_Permision } from '../sidebar/model';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable()
export class Common {
  private getProfiles = new BehaviorSubject<any>(undefined);

  triggerGetProfiles(param: any) {
    this.getProfiles.next(param);
  }

  getEventSubject(): BehaviorSubject<any> {
    return this.getProfiles;
  }
  //public Permission: Parent_Permision[];
  public IdUser: string = "";
  public Default: boolean = true;;
  router: any;
  public static activeLang: boolean;

  //   public setPermisison(permision: Parent_Permision[]) {
  //     this.Permission = permision;
  //   }

}
